import {
  DomainSessionId,
  DomainUserId,
  HealthcareSessionId,
  HealthcareUserId,
} from '@hc-frontend/core-types';
import { z } from 'zod';

import { SeniorCheck } from '../medicare-advantage-survey-answers';

export const UpdateProspectSeniorCheckParameters = z.object({
  userId: HealthcareUserId,
  sessionId: HealthcareSessionId,
  domainUserId: DomainUserId.optional(),
  domainSessionId: DomainSessionId.optional(),
  seniorCheck: SeniorCheck,
});

export type UpdateProspectSeniorCheckParameters = z.infer<
  typeof UpdateProspectSeniorCheckParameters
>;
